import { AbstractControl, ValidationErrors } from '@angular/forms';
import dayjs from 'dayjs';
import { formatTime } from '../../helpers/dateTimeFormatter';

//
export function validateEmail(control: AbstractControl) {
  if (!control.value) {
    return null;
  }
  // const regex = new RegExp("^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$");

  const regex = new RegExp("^(?!.*\\.@)[a-zA-Z0-9._%'+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$");
  const valid = regex.test(control.value);
  return valid ? null : { invalidEmail: true };
}

export function validateEmail1(control: AbstractControl) {
  if (!control.value) {
    return null;
  }
  const regex = new RegExp(/^(?!.*\.\.@)[^.]+(\.[^.]+)?@[^.]+\..+$/);
  const valid = !regex.test(control.value);
  return valid ? null : { invalidEmail: true };
}
export function validateUsername(control: AbstractControl) {
  if (!control.value) {
    return null;
  }
  const regex = new RegExp('^[ A-Za-z0-9_@.#&+-]{4,34}$');
  const valid = regex.test(control.value);
  return valid ? null : { invalidEmail: true };
}

export function validateMobileNumber(control: AbstractControl) {
  if (!control.value) {
    return null;
  }
  const regex = new RegExp('^[0-9.-]*$');
  const valid = regex.test(control.value);
  return valid ? null : { invalidNumber: true };
}

export function validateName(control: AbstractControl) {
  if (!control.value) {
    return null;
  }
  const regex = new RegExp('^[a-zA-Z]*$');
  // const regex = new RegExp('^[a-zA-Z\s()-]+$');

  const valid = regex.test(control.value);
  return valid ? null : { invalidName: true };
}

export function validateNameAndSpace(control: AbstractControl) {
  if (!control.value) {
    return null;
  }
  const regex = new RegExp('^[a-zA-Z ]*$');
  // const regex = new RegExp('^[\\p{L} ]*$', 'u');
  const valid = regex.test(control.value);
  return valid ? null : { invalidName: true };
}

export function validatePassword(control: AbstractControl) {
  return new Promise((resolve) => {
    if (!control.value) {
      resolve(null);
    }
    const regex = new RegExp(/^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/);
    const valid = regex.test(control.value);
    resolve(valid ? null : { invalidPassword: true });
  });
}

export function validateUserSchoolIdentityCode(control: AbstractControl) {
  return new Promise((resolve) => {
    if (!control.value) {
      resolve(null);
    }
    const regex = new RegExp('[a-zA-Z0-9]*$');
    const valid = regex.test(control.value);
    resolve(valid ? null : { invalidId: true });
  });
}
export function validateNoWhitespace(control: AbstractControl) {
  return new Promise((resolve) => {
    if (!control.value) {
      resolve(null);
    }
    const regex = new RegExp(/^\s*$/);
    const valid = !regex.test(control.value);
    resolve(valid ? null : { containsOnlyWhitespace: true });
  });
}

export function validateNameWithSpecialCharacters(control: AbstractControl) {
  if (!control.value) {
    return null;
  }
  const regex = new RegExp("^[ A-Za-z0-9_@.#&+('Ã¡)-]{0,34}$");
  const valid = regex.test(control.value);
  return valid ? null : { invalidEmail: true };
}

export function validateinputwithNumber(control: AbstractControl) {
  if (!control.value) {
    return null;
  }
  const regex = /^[a-zA-Z0-9]+$/;
  const valid = regex.test(control.value);
  return valid ? null : { invalidName: true };
}

export function validateNameAndSpaceAndSpecialCharacters(control: AbstractControl) {
  if (!control.value) {
    return null;
  }
  //support characters like  ñ, á, é, ü etc.
  const regex = new RegExp('^[\\p{L} ]*$', 'u');
  const valid = regex.test(control.value);
  return valid ? null : { invalidName: true };
}

export function validateNameWithSpacesAndHyphens(control: AbstractControl) {
  if (!control.value) {
    return null;
  }
  //support characters like  ñ, á, é, ü etc.
  const regex = new RegExp('^[\\p{L} -]*$', 'u');
  const valid = regex.test(control.value);
  return valid ? null : { invalidName: true };
}

export function validateAlphaNumberWithSpace(control: AbstractControl) {
  if (!control.value) {
    return null;
  }
  const regex = /^[a-zA-Z0-9 ]*$/;
  const valid = regex.test(control.value);
  return valid ? null : { invalidName: true };
}

/* -------------------------------------------------------------------------- */
/*                       DATE/TIME COMPARISON VALIDATOR                       */
/* -------------------------------------------------------------------------- */

export function dateTimeValidator(startTimeControl: AbstractControl, mode: 'time' | 'date' | 'datetime' = 'time') {
  return (endTimeControl: AbstractControl): ValidationErrors | null => {
    const startValue = startTimeControl.value;
    const endValue = endTimeControl.value;
    if (!startValue || !endValue) return null;

    const start = dayjs(startValue);
    const end = dayjs(endValue);

    if (!start.isValid() || !end.isValid()) {
      return { invalidDateTime: true };
    }

    switch (mode) {
      case 'datetime':
        if (end.isSame(start) || end.isBefore(start)) {
          return { endDateTimeBeforeStart: true };
        }
        break;

      case 'date':
        if (end.isBefore(start) || end <= start) {
          return { endDateBeforeStartDate: true };
        }
        break;

      case 'time':
      default:
        if (formatTime(endValue) <= formatTime(startValue)) {
          return { endTimeLessThanStartTime: true };
        }
        break;
    }

    return null;
  };
}

export function validateCDSNumber(control: AbstractControl) {
  if (!control.value) {
    return null;
  }
  const regex = /^\d{14}$/;
  const valid = regex.test(control.value);
  return valid ? null : { invalidNumber: true };
}

export function validateInputWithNumberNoSpace(control: AbstractControl): ValidationErrors | null {
  if (!control.value) return null;

  const cleanedValue = control.value.toString().replace(/\s+/g, '');
  if (cleanedValue !== control.value) {
    control.setValue(cleanedValue, { emitEvent: false });
  }
  const isValid = /^\d+$/.test(cleanedValue);
  return isValid ? null : { numberOnly: true };
}

export function validateAlphanumericWithSpecialCharacters(control: AbstractControl) {
  if (!control.value) {
    return null;
  }
  const regex = new RegExp("^[A-Za-z0-9 !#$%&'()*+,-./:;<=>?@[\\]^_`{|}~]+$");
  const valid = regex.test(control.value);
  return valid ? null : { invalidName: true };
}

// School End Time Validator
export function schoolEndTimeValidator(startTimeControl: AbstractControl, date = false) {
  return (endTimeControl: AbstractControl): ValidationErrors | null => {
    let startTime = startTimeControl.value;
    let endTime = endTimeControl.value;

    if (!startTime || !endTime) {
      return null;
    }
    if (date) {
      const startDate = dayjs(startTime);
      const endDate = dayjs(endTime);
      if (endDate.isBefore(startDate) || endDate <= startDate) {
        return { endTimeLessThanStartTime: true };
      }
    } else {
      if (formatTime(endTime) <= formatTime(startTime)) {
        return { endTimeLessThanStartTime: true };
      }
    }

    return null;
  };
}
